import React from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { BaseFirstNameInput } from 'src/components/enterprise/components/BaseFirstNameInput/BaseFirstNameInput';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface InvoiceContactFirstNameControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export const InvoiceContactFirstNameControl: React.FC<InvoiceContactFirstNameControlProps> =
  ({ name, id, rules }) => {
    return (
      <BaseFirstNameInput
        name={name}
        id={id}
        label={addAsterisk('First Name', rules)}
        rules={rules}
      />
    );
  };
